import React from "react";
import "./footer.scss";
import mobileBanner from "../assets/mobile_banner.png";
import footerDesktop from "../assets/footerDesktop.png";

const FooterAll = () => {
  const { mobileAdIcon } =
    JSON.parse(sessionStorage.getItem("customtheme")) || {};
  return (
    <>
      {mobileAdIcon ? (
        <div className="all-report-footer-block">
          <img src={mobileAdIcon} alt="logo" className="all-logo-imgs" />
        </div>
      ) : (
        <div className="all-report-footer-block">
          <img src={mobileBanner} alt="logo" className="all-logo-img" />
          <img src={footerDesktop} alt="logo" className="desktop-img" />
        </div>
      )}
    </>
  );
};

export default FooterAll;
